/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartsendbutton3Inputs */

const en_authstartsendbutton3 = /** @type {(inputs: Authstartsendbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email me the sign-in link`)
};

const pt_authstartsendbutton3 = /** @type {(inputs: Authstartsendbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar-me o link de acesso`)
};

/**
* | output |
* | --- |
* | "Email me the sign-in link" |
*
* @param {Authstartsendbutton3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartsendbutton3 = /** @type {((inputs?: Authstartsendbutton3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartsendbutton3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartsendbutton3(inputs)
	return pt_authstartsendbutton3(inputs)
});
export { authstartsendbutton3 as "authStartSendButton" }